var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_639_07523"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_639_07523)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,2.25C3,2.25,15,2.25,15,2.25C15.1989,2.2500000000000004,15.3897,2.3290178,15.5303,2.46967C15.6709,2.610323,15.75,2.801088,15.75,3C15.75,3,15.75,15,15.75,15C15.75,15.1989,15.6709,15.3897,15.5303,15.5303C15.3897,15.6709,15.1989,15.75,15,15.75C15,15.75,3,15.75,3,15.75C2.801088,15.75,2.610323,15.6709,2.46967,15.5303C2.3290178,15.3897,2.2500000000000004,15.1989,2.25,15C2.25,15,2.25,3,2.25,3C2.25,2.801088,2.3290178,2.610323,2.46967,2.46967C2.610323,2.3290178,2.801088,2.2500000000000004,3,2.25C3,2.25,3,2.25,3,2.25C3,2.25,3,2.25,3,2.25ZM8.25,8.25C8.25,8.25,5.25,8.25,5.25,8.25C5.25,8.25,5.25,9.75,5.25,9.75C5.25,9.75,8.25,9.75,8.25,9.75C8.25,9.75,8.25,12.75,8.25,12.75C8.25,12.75,9.75,12.75,9.75,12.75C9.75,12.75,9.75,9.75,9.75,9.75C9.75,9.75,12.75,9.75,12.75,9.75C12.75,9.75,12.75,8.25,12.75,8.25C12.75,8.25,9.75,8.25,9.75,8.25C9.75,8.25,9.75,5.25,9.75,5.25C9.75,5.25,8.25,5.25,8.25,5.25C8.25,5.25,8.25,8.25,8.25,8.25C8.25,8.25,8.25,8.25,8.25,8.25Z",
    fill: "#DCE0EB",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddgroup);
export default __webpack_public_path__ + "static/media/addgroup.ce0a881a217f930889fb9456ddb986de.svg";
export { ForwardRef as ReactComponent };